/**
 * Created by Rodrigo Quesada on 10/12/16.
 */
import ProjectionInformation = Model.ProjectionInformation;
import {MixinConstructor} from '../../../common/mixins/mixins';
import {EmptyClass} from '../../../common/mixins/empty-class.class';

export interface  Model<T extends Model<T>> {
    TYPE: Model.Type<T>;
    subProjectionInformation?: ProjectionInformation;

    exists: boolean;
}
export module Model {
    export interface Type<T extends Model<T>> {
        readonly projectionInformation?: ProjectionInformation;
        new (): T;
        new (jsonData: any): T;
    }

    export class ProjectionInformation {
        constructor(readonly name: string) {
        }
    }
}

export const ModelMixin = <B extends MixinConstructor<object>, M extends Model<M>>(Base: B = EmptyClass as B) => {
    return class extends Base {

        exists: boolean = false;

        constructor(...args: any[]) { super(...args); }
    };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/model.class.ts